import React, { FC } from 'react';

import { ContentLocalesI } from '~src/interfaces/session.types';
import { translateContent } from '~src/services/translationServices';

import { NpsValContainer, NpsValue } from './displayNpsValues.sc';

interface OwnProps {
  labels: ContentLocalesI[];
}

const DisplayNpsValues: FC<OwnProps> = React.memo(props => {
  return (
    <NpsValContainer>
      <NpsValue>{props.labels[0] ? translateContent(props.labels[0]) : null}</NpsValue>
      <NpsValue>{props.labels[1] ? translateContent(props.labels[1]) : null}</NpsValue>
    </NpsValContainer>
  );
});

export default DisplayNpsValues;
